<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-LianLang`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.06754 2.24904C1.15701 2.09488 1.32176 2 1.5 2H22.5C22.6782 2 22.843 2.09488 22.9325 2.24904C23.0219 2.40319 23.0226 2.59332 22.9341 2.74807L21 6.13278V21H23C23.2761 21 23.5 21.2239 23.5 21.5C23.5 21.7761 23.2761 22 23 22H16C15.7239 22 15.5 21.7761 15.5 21.5V13.5C15.5 11.567 13.933 10 12 10C10.067 10 8.5 11.567 8.5 13.5V21.5C8.5 21.7761 8.27614 22 8 22H1C0.723858 22 0.5 21.7761 0.5 21.5C0.5 21.2239 0.723858 21 1 21H3V6.13278L1.06588 2.74807C0.977449 2.59332 0.978084 2.40319 1.06754 2.24904ZM4 6.5V21H7.5V13.5C7.5 11.0147 9.51472 9 12 9C14.4853 9 16.5 11.0147 16.5 13.5V21H20V6.5H4ZM20.2098 5.5L21.6384 3H2.36159L3.79016 5.5H20.2098Z"/></svg>
</template>
<script>

export default {
  name: 'IconLianLang',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
